import React from 'react';
import AppLoader from './AppLoader';

/**
 * Full-viewport boot loader.
 *
 * Kept as a named entry point for the two app-level gates (`Observer` and the
 * lazy-route `<Suspense>` fallback); the appearance itself lives in
 * `AppLoader` so those gates cannot drift apart again.
 */
const LoadingPage = () => <AppLoader variant="page" />;

export default LoadingPage;
